import './main/main-module';
import './templates/templates-module';

/**
 * @ngdoc object
 * @name documents
 * @description
 *
 */
angular
    .module('festzelt-os.documents', [
        'ui.router',
        'festzelt-os.components',
        'festzelt-os.documents.main',
        'festzelt-os.documents.templates',
        //'ngListView'
    ]);

require('./documents-routes');



// WEBPACK FOOTER //
// ./src/app/pages/documents/documents-module.js